export default (imgModule): Promise<string> => {
  // const canvas = document.createElement('canvas');
  // canvas.width = img.width;
  // canvas.height = img.height;

  // // Copy the image contents to the canvas
  // const ctx = canvas.getContext('2d');
  // ctx.drawImage(img, 0, 0);

  // // Get the data-URL formatted image
  // // Firefox supports PNG and JPEG. You could check img.src to
  // // guess the original format, but be aware the using "image/jpg"
  // // will re-encode the image.
  // const dataURL = canvas.toDataURL('image/png');

  // return dataURL;
  return new Promise((resolve, reject) => {
    const img = new Image();
    // img.setAttribute('crossOrigin', 'anonymous');
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    img.onerror = (error) => {
      reject(error);
    };
    img.src = imgModule;
  });
};
